"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIME_TYPE = void 0;
var MIME_TYPE;
(function (MIME_TYPE) {
    MIME_TYPE["Image"] = "image/jpeg";
    MIME_TYPE["Video"] = "video/mp4";
})(MIME_TYPE = exports.MIME_TYPE || (exports.MIME_TYPE = {}));
